import React from "react";
import CircularSpinner from "components/common/loaders/CircularSpinner";
import { useLocale } from "lib/hooks/useLocale";
import useSendAnalyticsEvent from "lib/hooks/useAnalytics";
import { analyticsEvents } from "lib/utils/constants";
import { classNames } from "lib/utils/helpers";
import UPICartIcons from "assests/images/cart-upi-icons.svg";
import TrustBadgeGray from "assests/images/trust-badge-gray.svg";
import DotsLoader from "../loaders/DotsLoader";

interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  type?: "button" | "submit" | "reset";
  buttonText?: string;
  height?: string;
  width?: string;
  borderRadius?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  appearance?: string;
  paymentGateways?: boolean;
  isCheckout?: boolean;
  hideButton?: boolean;
  customTermsLink?: string;
  containerClassName?: string;
  showUpiIcon?: boolean;
  customization?: {
    backgroundColor: string;
    textColor: string;
    borderRadius: number;
  };
}

const PrimaryButton: React.FC<ButtonProps> = ({
  type = "button",
  buttonText = "Confirm",
  height = "h-14",
  width = "w-full",
  isDisabled = false,
  isLoading = false,
  appearance = "solid",
  borderRadius = "rounded-xl",
  paymentGateways = false,
  isCheckout = false,
  hideButton = false,
  customTermsLink,
  className,
  containerClassName,
  showUpiIcon = false,
  customization,
  ...rest
}) => {
  const { t } = useLocale();
  const { sendAnalyticsEvent } = useSendAnalyticsEvent();
  return (
    <div className={classNames("flex w-full flex-col items-center space-y-2", containerClassName ?? "")}>
      <button
        style={{
          backgroundColor: customization?.backgroundColor,
          borderRadius: customization?.borderRadius,
        }}
        className={classNames(
          `flex py-1.5 flex-row items-center gap-2 space-x-4 whitespace-nowrap cursor-pointer bg-primary-dark text-btnPrimaryText px-4 text-base font-medium`,
          isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
          borderRadius,
          appearance === "outline" ? "border-2 border-primary-dark bg-white" : "",
          hideButton ? "hidden" : "",
          height,
          width,
          className ?? "",
          showUpiIcon && !isLoading ? "justify-between" : "justify-center",
        )}
        type={type}
        disabled={isLoading || isDisabled}
        {...rest}>
        <span
          className="text-text-md-semibold flex gap-2 items-center"
          style={{ color: customization?.textColor }}>
          {isLoading ? <DotsLoader color={customization?.textColor} /> : `${buttonText}`}
        </span>
        {showUpiIcon && !isLoading && <img className="h-10 w-auto" src={UPICartIcons} alt={""} />}
      </button>
      {isCheckout && (
        <div className="flex w-full flex-row items-center justify-center space-x-1">
          <img src={TrustBadgeGray} className="h-4" alt={"shopflo-logo"} />
        </div>
      )}
    </div>
  );
};

export default PrimaryButton;
